// 将秒数转换为 "Dd:Hh:Mm" 格式的字符串

import { ProgramSteps } from "../store/backend";

export const formatTime = (seconds: number) => {
    const days = Math.floor(seconds / (24 * 3600));
    seconds %= 24 * 3600;
    const hours = Math.floor(seconds / 3600);
    seconds %= 3600;
    const minutes = Math.floor(seconds / 60);

    return `${days}d:${hours}h:${minutes}m`;
}

// C转F
export const cToF = (celsius: number) => {
    return (celsius * 9 / 5 + 32).toFixed(0);
}

export function calcProgramStepsDuration(programSteps: ProgramSteps[]): string {
    // 先把所有时间转成总分钟数
    const totalMinutes = programSteps.reduce((sum, step) => {
      const minutes =
        step.day * 24 * 60 +
        step.hour * 60 +
        step.minutes
      return sum + minutes
    }, 0)
  
    const minutesPerDay = 24 * 60
    const minutesPerHour = 60
  
    const days = Math.floor(totalMinutes / minutesPerDay)
    const remainingAfterDays = totalMinutes % minutesPerDay
  
    const hours = Math.floor(remainingAfterDays / minutesPerHour)
    const minutes = remainingAfterDays % minutesPerHour
  
    return `${days}d:${hours}h:${minutes}m`
  }